import { motion, AnimatePresence } from 'framer-motion';

interface OfflineBannerProps {
  isOnline: boolean;
  message: string;
}

export function OfflineBanner({ isOnline, message }: OfflineBannerProps) {
  return (
    <AnimatePresence>
      {!isOnline && (
        <motion.div
          initial={{ y: -60, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -60, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 320, damping: 30 }}
          className="fixed top-0 left-0 right-0 z-[90] bg-kiosk-highlight text-white text-kiosk-xs font-semibold text-center py-2 kiosk:py-[1vw] px-4"
          role="status"
        >
          {message}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
